import { skipToken, useQuery } from '@tanstack/react-query';

import { ShortUrl } from '@air/api';

export const LIST_CUSTOM_FIELDS_QUERY_KEY = 'list-custom-fields';

export const getShortUrlListCustomFieldsQueryKey = (params: UseShortUrlListCustomFieldsParams) => [
  LIST_CUSTOM_FIELDS_QUERY_KEY,
  params,
];

export type UseShortUrlListCustomFieldsParams = {
  shortId: string | undefined;
};

export const useShortUrlListCustomFields = ({ shortId, ...params }: UseShortUrlListCustomFieldsParams) => {
  return useQuery({
    queryFn: !shortId
      ? skipToken
      : () => {
          return ShortUrl.listCustomFields(shortId, { ...params, limit: 100 });
        },
    queryKey: getShortUrlListCustomFieldsQueryKey({ shortId, ...params }),
  });
};
